(function () {
  var socialObserver = null;

  function frameHeight(frame) {
    var attr = parseInt(frame.getAttribute('height') || '0', 10);
    if (attr > 0) return attr;
    var styled = parseInt(frame.style.height || '0', 10);
    if (styled > 0) return styled;
    return 0;
  }

  function pruneSocial(section) {
    if (!section) return;
    var grid = section.querySelector('.geny-social__grid');
    if (!grid) return;
    if (!grid.querySelector('.geny-social__item, .geny-social__fallback')) section.remove();
  }

  function dropSocialItem(item) {
    var section = item.closest('.geny-social');
    item.remove();
    pruneSocial(section);
  }

  function fitSocialItem(item) {
    if (!item || !item.isConnected) return;
    var frame = item.querySelector('iframe');
    if (!frame) return;
    var available = item.clientWidth;
    if (available < 40) return;
    var platform = item.dataset.genyPlatform;
    var pin = (platform === 'instagram' || platform === 'tiktok') && available < 300;

    frame.style.transform = '';
    if (pin) item.classList.add('is-fitted');
    else item.classList.remove('is-fitted');

    var natural = frame.offsetWidth;
    var naturalHeight = frame.offsetHeight;
    if (naturalHeight < 40) return;
    if (natural > available + 4) {
      var scale = available / natural;
      frame.style.transformOrigin = 'top left';
      frame.style.transform = 'scale(' + scale + ')';
      item.style.height = Math.ceil(naturalHeight * scale) + 'px';
    } else {
      item.style.height = '';
    }
  }

  function onSocialMessage(event) {
    var data = event.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || typeof data !== 'object') return;
    var frame = null;
    document.querySelectorAll('.geny-social iframe').forEach(function (candidate) {
      if (candidate.contentWindow === event.source) frame = candidate;
    });
    if (!frame) return;
    var item = frame.closest('.geny-social__item');
    if (!item) return;
    var origin = event.origin || '';

    if (origin.indexOf('instagram.com') !== -1 && data.type === 'MEASURE' && data.details) {
      var height = Number(data.details.height);
      if (height > 0 && height < 220) {
        dropSocialItem(item);
        return;
      }
      if (height >= 220) {
        item.dataset.genyLive = '1';
        window.requestAnimationFrame(function () { fitSocialItem(item); });
      }
    }

    if (origin.indexOf('youtube.com') !== -1 && data.event === 'onError') {
      var code = Number(data.info);
      if (code === 100 || code === 101 || code === 150 || code === 153) dropSocialItem(item);
    }
  }

  function watchSocial(scope) {
    if (!window.__genySocialBound) {
      window.__genySocialBound = true;
      window.addEventListener('message', onSocialMessage);
    }
    if (!socialObserver && 'ResizeObserver' in window) {
      socialObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var width = String(Math.round(entry.contentRect.width));
          if (entry.target.dataset.genyWidth === width) return;
          entry.target.dataset.genyWidth = width;
          entry.target.querySelectorAll('.geny-social__item').forEach(fitSocialItem);
        });
      });
    }
    scope.querySelectorAll('.geny-social__grid').forEach(function (grid) {
      if (socialObserver && !grid.dataset.genyObserved) {
        grid.dataset.genyObserved = '1';
        socialObserver.observe(grid);
      }
    });
    scope.querySelectorAll('.geny-social__item[data-geny-platform="instagram"], .geny-social__item[data-geny-platform="tiktok"]').forEach(function (item) {
      if (item.dataset.genySocial) return;
      item.dataset.genySocial = '1';
      window.setTimeout(function () {
        if (!item.isConnected || item.dataset.genyLive === '1') return;
        var frame = item.querySelector('iframe');
        if (!frame) return;
        var measured = frameHeight(frame) || frame.offsetHeight;
        if (measured >= 220) {
          item.dataset.genyLive = '1';
          fitSocialItem(item);
          return;
        }
        dropSocialItem(item);
      }, 8000);
    });
  }

  function init(root) {
    var scope = root && root.querySelector ? root : document;

    var links = scope.querySelectorAll('.geny-toc a[href^="#"]');
    var targets = [];
    links.forEach(function (link) {
      if (link.dataset.genyToc) return;
      link.dataset.genyToc = '1';
      var el = document.getElementById(link.getAttribute('href').slice(1));
      if (el) targets.push({ el: el, link: link });
    });
    if (targets.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          targets.forEach(function (item) {
            var on = item.el === entry.target;
            item.link.classList.toggle('is-active', on);
            if (on) item.link.setAttribute('aria-current', 'true');
            else item.link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
      targets.forEach(function (item) { observer.observe(item.el); });
    }

    scope.querySelectorAll('.geny-calc').forEach(function (calc) {
      if (calc.dataset.genyBound) return;
      calc.dataset.genyBound = '1';
      var receiver = calc.querySelector('[data-geny-r]');
      var coupler = calc.querySelector('[data-geny-c]');
      var value = calc.querySelector('[data-geny-result]');
      var note = calc.querySelector('[data-geny-note]');
      if (!receiver || !coupler || !value || !note) return;

      function update() {
        var rv = receiver.value.trim();
        var cv = coupler.value.trim();
        if (rv === '' || cv === '' || Number.isNaN(Number(rv)) || Number.isNaN(Number(cv))) {
          value.textContent = '—';
          note.textContent = 'Enter both heights';
          return;
        }
        var drop = Number(rv) - Number(cv);
        if (drop > 0) {
          value.textContent = drop + ' mm drop';
          note.textContent = 'Coupler sits lower than the receiver';
        } else if (drop < 0) {
          value.textContent = Math.abs(drop) + ' mm rise';
          note.textContent = 'Coupler sits higher than the receiver';
        } else {
          value.textContent = 'Level';
          note.textContent = 'No drop or rise needed';
        }
      }

      receiver.addEventListener('input', update);
      coupler.addEventListener('input', update);
    });

    function ensureScript(src, onload) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (onload) onload();
        return;
      }
      var script = document.createElement('script');
      script.async = true;
      script.src = src;
      if (onload) script.onload = onload;
      document.body.appendChild(script);
    }

    if (scope.querySelector('.instagram-media')) {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      } else {
        ensureScript('https://www.instagram.com/embed.js', function () {
          if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
        });
      }
    }

    if (scope.querySelector('.tiktok-embed')) {
      ensureScript('https://www.tiktok.com/embed.js');
    }

    watchSocial(scope);

    scope.querySelectorAll('[data-geny-copy]').forEach(function (button) {
      if (button.dataset.genyBound) return;
      button.dataset.genyBound = '1';
      button.addEventListener('click', function () {
        var live = button.parentElement.querySelector('[data-geny-copied]');
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(window.location.href).then(function () {
          if (!live) return;
          live.textContent = 'Copied';
          window.setTimeout(function () { live.textContent = ''; }, 2000);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
